import React, { Component } from 'react';
import $ from 'jquery';
import Header from './components/Header';
import Footer from './components/Footer';
import Professional from './components/Professional';
import Education from './components/Education';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

export class Home extends Component {


  handleScroll = (link) => {
    this.scrNav(link);
  }
  scrNav = (link) => {
    var sTop = $(window).scrollTop();
    $('section').each(function () {
      var id = $(this).attr('id'),
        offset = $(this).offset().top - 200,
        height = $('section').height();
      if (sTop >= offset && sTop < offset + height) {
        link.removeClass('active');
        $('#navbar').find('[data-scroll="' + id + '"]').addClass('active');
      }
    });
  }
  handleNavbar = () => {
    var link = $('#navbar a.dot');
    // var that = this;

    // Move to specific section when click on menu link
    link.on('click', function (e) {

      var target = '';



      e.preventDefault()
      var href = $(this).attr('href');
      href = href[0] === '/' ? href.slice(1) : href;
      target = $(href);
      var tip = 0;
      switch (href.slice(1)) {
        case 'home':
        case 'contact':
          tip = 0;


          break;
        case 'portfolio':
          tip = 100;
          break;
        case 'professional':
        case 'education':
          tip = 200;
          break;

        default:
          break;
      }
      $('html, body').animate({
        scrollTop: target.offset().top + tip
      }, 300, "swing");
      $(this).addClass('active');
    });

    // Run the scrNav when scroll
    $(window).on('scroll', this.handleScroll.bind(this, link));
    this.scrNav(link);
  }

  componentDidMount = () => {
    $(document.body).removeClass("modal-open");
    this.handleNavbar()
  }
  componentDidUpdate = () => {
    this.handleNavbar()
  }
  componentWillUnmount = () => {
    $(window).off('scroll', this.handleScroll.bind(this))
  }
  render() {
    return (
      <>
        <Navbar />
        <Header />
        <Professional />
        <Portfolio />
        <Education />
        <Contact />
        <Footer />
      </>
    );
  }
}

export default Home;
